const { anime, isInViewportPromise } = window;

console.log("Grid view script loaded");



isInViewportPromise('.grid-container').then(entries => {
    anime({
        targets: '.grid-container > *:not(.wp-block-group)',
        opacity: [0, 1],
        translateY: [20, 0],
        delay: anime.stagger(200),
        easing: 'easeInOutQuad',
        duration: 500
    });
});